import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { HomePage } from "./pages/HomePage";
import { MunicipalitiesFrontPage } from "./pages/MunicipalitiesFrontPage";
import { SectorsFrontPage } from "./pages/SectorsFrontPage";
import { FileArchivePage } from "./pages/FileArchivePage";
import { TotalRankingPage } from "./pages/TotalRankingPage";
import { oauth, isknr, isyear, issector, clrstg, urllogout, urlstartpage } from '../utils';
import * as API from './API';
export const Router = (config, pageData) => {
    var _a, _b, _c, _d, _e;
    if (!config || !config.guid) {
        console.error(`Missing config or guid for plugin ${(_a = config.pluginName) !== null && _a !== void 0 ? _a : "[no name]"}`);
        return _jsx(_Fragment, {});
    }
    const hashParts = window.location.hash.substring(1).split('?');
    const path = hashParts[0].split('/');
    const query = ((_b = hashParts[1]) !== null && _b !== void 0 ? _b : '')
        .split('&')
        .reduce((acc, cur) => {
        const [key, value] = cur.split('=');
        acc[decodeURIComponent(key)] = decodeURIComponent(value);
        return acc;
    }, {});
    let page = null;
    const q = new URL(window.location.href);
    // Path encoded as search parameter 'q'?
    if (q.searchParams.has('q')) {
        q.hash = (_c = q.searchParams.get('q')) !== null && _c !== void 0 ? _c : 'hjem';
        q.searchParams.delete('q');
        window.location.href = q.toString();
    }
    const code = q.searchParams.get('code');
    if (code) {
        oauth.get_token();
    }
    switch ((_d = path[0]) !== null && _d !== void 0 ? _d : '') {
        case 'login':
            oauth.start();
            break;
        case 'logout':
            clrstg();
            window.location.href = urllogout();
            break;
        case 'hjem': // Explicitly going to the landing page, regardless of subsciber status
            page = _jsx(HomePage, { pageData: Object.assign(Object.assign({}, pageData), { guid: config.guid }) });
            break;
        case 'totalrangering':
            page = _jsx(TotalRankingPage, { pageData: Object.assign(Object.assign({}, pageData), { knr: path[1], aar: (_e = path[2]) !== null && _e !== void 0 ? _e : null }) });
            break;
        case 'kommuner':
            switch (path[2]) {
                case 'sektorer':
                    if (isknr(path[1]) && issector(path[3])) {
                        page = _jsx(SectorsFrontPage, { pageData: Object.assign(Object.assign({}, pageData), { knr: path[1], sector: path[3] }) });
                    }
                    break;
                default:
                    if (isknr(path[1])) {
                        page = _jsx(MunicipalitiesFrontPage, { pageData: Object.assign(Object.assign({}, pageData), { knr: path[1] }) });
                    }
                    else {
                        page = _jsx(MunicipalitiesFrontPage, { pageData: Object.assign(Object.assign({}, pageData), { knr: '' }) });
                    }
                    break;
                case 'filarkiv':
                    if (isknr(path[1]) && isyear(path[4])) {
                        page = _jsx(FileArchivePage, { pageData: Object.assign(Object.assign({}, pageData), { knr: path[1], query: { knr: path[1], year: path[4] } }) });
                    }
                    else if (isknr(path[1])) {
                        page = _jsx(FileArchivePage, { pageData: Object.assign(Object.assign({}, pageData), { knr: path[1], query: { knr: path[1] } }) });
                    }
                    else {
                        page = _jsx(FileArchivePage, { pageData: Object.assign(Object.assign({}, pageData), { knr: path[1], query: {} }) });
                    }
                    break;
            }
            break;
        default:
            page = _jsx(HomePage, { pageData: Object.assign(Object.assign({}, pageData), { guid: config.guid }) });
            Promise.all([API.fetchSubscriberStatus(), API.fetchDatabaseInfo()])
                .then(([status, info]) => {
                if (status.isEligible) {
                    window.location.hash = urlstartpage(info.beste_kommune);
                }
            });
    }
    return page !== null && page !== void 0 ? page : _jsx(_Fragment, {});
}; // class KbApp
